module.exports = __webpack_public_path__ + "static/scale-model-of-reno-nevada-38122e0d4f671930e52bcd92a4c6703c.png";